import { CommonProductQueryParams } from '~/api/easy-estimator-api/commonProductQueryParams';
import { easyEstimatorApi } from '~/api/easy-estimator-api/easyEstimatorService';
import { ApiUrl } from '~/core/enums';
import { EndSplashProduct } from '~/core/models';

export const endSplashApi = easyEstimatorApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchEndSplash: builder.query<EndSplashProduct[], CommonProductQueryParams>(
      {
        query: ({ params }) => ({
          url: ApiUrl.LAMINATE_SPLASHES,
          method: 'GET',
          params,
        }),
      }
    ),
  }),
});

export const { useFetchEndSplashQuery } = endSplashApi;
